import React, { Component } from "react";
import { connect } from "react-redux";
import Loader from "react-loader-advanced";
import { formatSecondsForLongDisplay } from "./utils/timeUtils";

import { bindActionCreators } from "redux";
import * as NotificationActionCreators from "../actions/message";
import * as MessagesActionCreators from "../actions/messages";

import _ from "lodash";
import { List, ListItem } from "material-ui/List";
import IconButton from "material-ui/IconButton";
import Divider from "material-ui/Divider";
import ReactPlayer from "react-player";

import AppFrame from "./Appframe/AppFrame";
import Title from "../components/common/Title";
import WrapDialogue from "../components/common/WrapDialogue";
import PushNotificationSender from "../components/common/PushNotificationSender";
import ActionButton from "../components/common/ActionButton";
import IconDelete from "material-ui/svg-icons/action/delete-forever";
import IconDone from "material-ui/svg-icons/action/done";
import IconDoneAll from "material-ui/svg-icons/action/done-all";

import colors from "../styles/colors";
import layout from "../styles/layout";
import { ContentAddCircle } from "material-ui/svg-icons";
import { RaisedButton, Badge } from "material-ui";
import { Mixpanel } from "../mixpanel";
import events from "../services/events";

const style = {
  unreadMessage: {
    color: colors.primary,
    fontWeight: "bold",
  },
  messageDetailTextArea: {
    margin: 20,
    color: colors.text,
    whiteSpace: "pre-wrap",
  },
  allMessages: {
    display: "flex",
    flexDirection: "row",
  },
  senders: {
    width: 250,
    borderRight: "solid 1px #cecece",
    marginRight: 25,
    paddingRight: 25,
  },
  messageContainer: {
    flex: 1,
  },
  userHeader: {
    fontSize: 14,
    padding: 0,
    margin: 0,
  },
  userHeaderUnread: {
    fontSize: 14,
    color: colors.steelBlue,
    padding: 0,
    margin: 0,
  },
  userDate: {
    fontSize: 10,
    padding: 0,
    margin: 0,
    width: "100%",
    textAlign: "right",
    display: "block",
  },
  sendNewButtonContainer: {
    position: "absolute",
    top: 15,
    right: 0,
  },
  timeFormat: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  selectedButton: {
    backgroundColor: "blue !important",
  },
  unreadMessageCount: {
    backgroundColor: colors.orange,
    color: "black",
  },
  icon: {
    fontSize: "x-small",
    marginRight: 5,
    marginTop: -2,
  },
};

class MessageInbox extends Component {
  constructor(props) {
    super(props);

    let userId = props.match.params.userId;

    this.state = {
      userId,
      isLoading: true,
      notificationData: [],
      currentNotification: {},
      currentMsg: {},
      filter: "Received",
      selectedContact: { sender: "" },
      selectedContactId: null,
      selectedContactName: "",
      inbox: [],
      messageList: [],
    };
    this.ViewNotification = this.ViewNotification.bind(this);
    this.ReplyNotification = this.ReplyNotification.bind(this);
    this.NotificationViewer = this.NotificationViewer.bind(this);
    this.NotificationSender = this.NotificationSender.bind(this);

    this.renderInbox = this.renderInbox.bind(this);
    this.renderMessageList = this.renderMessageList.bind(this);
  }

  componentWillMount() {
    Mixpanel.track("View message inbox", { "User ID": this.state.userId });
    this.props.getUserNotifications(this.state.userId); // use this.state.userId to fix loading at refresh (rehydrate after request)
    this.props.getUserInbox(this.state.userId); // use this.state.userId to fix loading at refresh (rehydrate after request)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      notificationData: nextProps.notifications,
      isLoading: false,
      inbox: nextProps.inbox,
      messageList: nextProps.messageList ? nextProps.messageList : [],
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderInbox() {
    return this.state.inbox.map((inboxItem) => {
      let currentRowStyle = {};
      if (inboxItem.unreadMessageCount > 0) {
        currentRowStyle = style.unreadMessage;
      }
      return (
        <div>
          <Divider />
          <ListItem
            style={currentRowStyle}
            primaryText={
              <div
                style={{
                  width: 250,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {inboxItem.firstName + " " + inboxItem.lastName}
                {inboxItem.unreadMsgCount > 0 && (
                  <Badge
                    badgeContent={inboxItem.unreadMsgCount}
                    badgeStyle={{
                      backgroundColor:
                        this.props.optionsType === "messages"
                          ? "white"
                          : this.props.whiteLabelSettings &&
                            this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : colors.accent,
                      color: "black",
                    }}
                  ></Badge>
                )}
              </div>
            }
            secondaryTextLines={2}
            onClick={() => {
              this.updateConversationView(inboxItem);
            }}
          />
        </div>
      );
    });
  }

  //Refresh conversation state data
  updateConversationView(inboxItem) {
    this.setState({
      isLoading: true,
      selectedContactId: inboxItem.userId,
      selectedContactName: inboxItem.firstName + " " + inboxItem.lastName,
    });
    this.props.getUserConversation(
      parseInt(this.state.userId, 10),
      inboxItem.userId,
      inboxItem.firstName + " " + inboxItem.lastName
    );
  }

  hasUnread(userId) {
    let hasUnread = false;
    this.state.notificationData.map((n) => {
      if (n.senderUserId === userId && !n.hasRead) {
        hasUnread = true;
      }
    });

    return hasUnread;
  }

  renderMessageList() {
    if (!this.state.selectedContactId) {
      return;
    }
    return this.state.messageList
      .filter((m) => {
        if (this.state.filter === "All") {
          return true;
        }
        if (this.state.filter === "Received") {
          return m.receiverUserId === parseInt(this.state.userId, 10);
        }
        return m.senderUserId === parseInt(this.state.userId, 10);
      })
      .filter((m) => this.state.filter !== "Received" || !m.archived)
      .map((message) => {
        let currentRowStyle = {};
        if (
          !message.viewed &&
          message.receiverUserId === parseInt(this.state.userId)
        ) {
          currentRowStyle = {
            color:
              this.props.whiteLabelSettings &&
              this.props.whiteLabelSettings.isWhiteLabel
                ? this.props.whiteLabelSettings.accentColor
                : colors.primary,
            fontWeight: "bold",
          };
        }
        return (
          <div>
            <Divider />
            <ListItem
              style={currentRowStyle}
              rightIconButton={
                message.receiverUserId === parseInt(this.state.userId) &&
                !message.archived && (
                  <IconButton
                    onClick={() => {
                      this.props.setMessageToArchived(message.messageId);
                    }}
                  >
                    <IconDelete />
                  </IconButton>
                )
              }
              primaryText={
                message.subject +
                (message.receiverUserId === parseInt(this.state.userId, 10) &&
                message.archived
                  ? " (ARCHIVED) "
                  : "")
              }
              secondaryTextLines={2}
              secondaryText={
                <div>
                  <div>{message.text}</div>
                  <div style={style.timeFormat}>
                    {parseInt(this.state.userId, 10) === message.senderUserId &&
                      message.receivedAt &&
                      !message.viewed && <IconDone style={style.icon} />}
                    {parseInt(this.state.userId, 10) === message.senderUserId &&
                      message.receivedAt &&
                      message.viewed && <IconDoneAll style={style.icon} />}
                    {formatSecondsForLongDisplay(message.createdAt.seconds)}
                  </div>
                </div>
              }
              onClick={() => {
                this.ViewNotification(message);
              }}
            />
          </div>
        );
      });
  }
  ViewNotification(msg) {
    if (!msg.viewed && msg.receiverUserId === parseInt(this.state.userId)) {
      this.props.decrementInboxUnreadCountForUser(this.state.selectedContactId);
      this.props.setMessageToViewed(msg.messageId);
    }
    this.setState({
      currentMsg: msg,
    });
    this.refs.NotificationViewer.open();
    Mixpanel.track("Message viewed", {
      "User ID": this.state.userId,
      "Message ID": msg.messageId,
    });
    events().trackUserEvent(
      "Message Viewed",
      null,
      null,
      null,
      null,
      this.state.userId,
      this.state.userId === msg.senderUserId
        ? msg.receiverUserId
        : msg.senderUserId,
      "portal",
      null,
      null,
      JSON.stringify({ messageId: msg.messageId })
    );
  }

  ReplyNotification() {
    this.refs.NotificationViewer.close();
    this.refs.NotificationSender.open();
  }

  NotificationViewer() {
    return (
      <WrapDialogue
        ref="NotificationViewer"
        title={
          this.state.currentMsg.subject +
          (this.state.currentMsg.archived &&
          this.state.currentMsg.receiverUserId ===
            parseInt(this.state.userId, 10)
            ? " (ARCHIVED) "
            : "")
        }
        content={
          <div>
            <div>
              {"Sent by " +
                this.state.currentMsg.senderName +
                " at " +
                (this.state.currentMsg.createdAt
                  ? formatSecondsForLongDisplay(
                      this.state.currentMsg.createdAt.seconds
                    )
                  : "")}
            </div>
            <br />
            <Divider />
            <div style={style.messageDetailTextArea}>
              {!_.isEmpty(this.state.currentMsg.videoURL) && (
                <div>
                  <ReactPlayer
                    url={this.state.currentMsg.videoURL}
                    controls={true}
                    height={180}
                    width={320}
                    onPlay={() => {
                      events().trackUserEvent(
                        "Video Watched",
                        null,
                        null,
                        null,
                        null,
                        this.state.userId,
                        this.state.currentMsg.senderUserId,
                        "portal",
                        null,
                        null,
                        JSON.stringify({
                          type: "Message Video",
                          messageId: this.state.currentMsg.messageId,
                        })
                      );
                    }}
                    onEnded={() => {
                      events().trackUserEvent(
                        "Video Watched Until End",
                        null,
                        null,
                        null,
                        null,
                        this.state.userId,
                        this.state.userId === this.state.currentMsg.senderUserId
                          ? this.state.currentMsg.receiverUserId
                          : this.state.currentMsg.senderUserId,
                        "portal",
                        null,
                        null,
                        JSON.stringify({
                          type: "Message Video",
                          messageId: this.state.currentMsg.messageId,
                        })
                      );
                    }}
                  />
                  <br />
                  <br />
                </div>
              )}
              {!_.isEmpty(this.state.currentMsg.photoURL) && (
                <div>
                  <img
                    alt="Message Attachment"
                    style={{ height: 180 }}
                    src={this.state.currentMsg.photoURL}
                  />
                  <br />
                  <br />
                </div>
              )}
              {this.state.currentMsg.text}
            </div>
            <br />
            <div style={{ width: 200 }}>
              {this.state.currentMsg.receiverUserId ===
                parseInt(this.state.userId) && (
                <ActionButton
                  label="Reply"
                  onClick={() =>
                    this.ReplyNotification(this.state.currentMsg.senderUserId)
                  }
                  whiteLabelSettings={this.props.whiteLabelSettings}
                />
              )}
            </div>
          </div>
        }
      />
    );
  }

  NotificationSender() {
    let windowTitle = `Reply To ${this.state.selectedContactName}`;
    let text = `\n\n\n-----Previous message-----\n\n${this.state.currentMsg.text}`;
    let sender = `${this.props.user.userInfo.firstName} ${this.props.user.userInfo.lastName} (${this.props.user.userInfo.email})`;
    return (
      <WrapDialogue
        ref="NotificationSender"
        title={windowTitle}
        content={
          <PushNotificationSender
            type="user"
            userId={this.props.userId}
            appCode={this.props.whiteLabelSettings.appCode}
            recipientUserId={this.state.selectedContactId}
            sender={sender}
            subject={"RE: " + this.state.currentMsg.subject}
            onComplete={() => this.refs.NotificationSender.close()}
            whiteLabelSettings={this.props.whiteLabelSettings}
            isReply={true}
          />
        }
      />
    );
  }

  sendPushNotification() {
    return (
      <div style={style.sendNewButtonContainer}>
        <RaisedButton
          primary={
            !this.props.whiteLabelSettings &&
            !this.props.whiteLabelSettings.isWhiteLabel
          }
          label="New Message"
          icon={<ContentAddCircle />}
          onClick={() => this.refs.sendPushNotificationDialogue.open()}
        />
        <WrapDialogue
          ref="sendPushNotificationDialogue"
          title={"New Message"}
          content={
            <PushNotificationSender
              type="user"
              userId={this.props.user.userId}
              appId={this.state.appId}
              appCode={this.props.whiteLabelSettings.appCode}
              recipientUserId={this.state.selectedContactId}
              sender={this.state.appInfo ? this.state.appInfo.author : ""}
              subject={this.state.appInfo ? this.state.appInfo.appName : ""}
              onComplete={() => this.refs.sendPushNotificationDialogue.close()}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          }
        />
      </div>
    );
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="My Messages"
        optionsType="messages"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Loader show={this.state.isLoading} message={"Loading..."}>
            <div style={style.allMessages}>
              <div style={style.senders}>
                <h1>Contacts</h1>
                <List>{this.renderInbox()}</List>
              </div>
              <div style={style.messageContainer}>
                <h1>
                  Messages{" "}
                  {this.state.selectedContactName &&
                    " with " + this.state.selectedContactName}
                </h1>
                {this.state.selectedContactId && (
                  <RaisedButton
                    backgroundColor={
                      this.state.filter === "Received"
                        ? this.props.whiteLabelSettings &&
                          this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : colors.accent
                        : "white"
                    }
                    onClick={() => this.setState({ filter: "Received" })}
                  >
                    Received
                  </RaisedButton>
                )}
                {this.state.selectedContactId && (
                  <RaisedButton
                    backgroundColor={
                      this.state.filter === "Sent"
                        ? this.props.whiteLabelSettings &&
                          this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : colors.accent
                        : "white"
                    }
                    onClick={() => this.setState({ filter: "Sent" })}
                  >
                    Sent
                  </RaisedButton>
                )}
                {this.state.selectedContactId && (
                  <RaisedButton
                    backgroundColor={
                      this.state.filter === "All"
                        ? this.props.whiteLabelSettings &&
                          this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : colors.accent
                        : "white"
                    }
                    onClick={() => this.setState({ filter: "All" })}
                  >
                    All
                  </RaisedButton>
                )}
                {this.state.selectedContactId && this.sendPushNotification()}
                <List>{this.renderMessageList()}</List>
              </div>
            </div>
          </Loader>
          {this.NotificationViewer()}
          {this.NotificationSender()}
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, message, messages, whiteLabelSettings }) {
  return {
    user: user,
    userId: user.userId,
    notifications: message.notifications,
    isLoading: message.isLoading,
    inbox: messages.inbox,
    messageList: messages.messageList,
    selectedMessageContactId: messages.selectedMessageContactId,
    selectedMessageContactName: messages.selectedMessageContactName,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...NotificationActionCreators,
    ...MessagesActionCreators,
  };
  return bindActionCreators(combinedActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageInbox);



// WEBPACK FOOTER //
// ./src/layout/MessageInbox.js